import { useContext } from "react";
import BorseContext from "../../context/borse";
import useBorseRequestCreateMutation from "../../hooks/mutations/useBorseRequestCreateMutation";
import useBorseRequestDeleteMutation from "../../hooks/mutations/useBorseRequestDeleteMutation";
import useBorseRequestUpdateMutation from "../../hooks/mutations/useBorseRequestUpdateMutation";
import DiscardRequestModal from "../discard-request-modal";

const BorseDiscardRequestModal = ({
  discardModal,
  setDiscardModal,
  formWatch = {},
  lastCompletedStep,
  skipUpdate = false,
}) => {
  const {
    labels,
    campaign,
    survey,
    currentRequest,
    formData,
    setCurrentRequest,
    setCurrentSectionIndex,
  } = useContext(BorseContext);

  const closeModal = () => setDiscardModal(false);

  const {
    mutateAsync: asyncDeleteRequest,
    isError,
    reset,
  } = useBorseRequestDeleteMutation(closeModal);

  const { mutateAsync: asyncUpdateRequest, isError: isUpdateError } =
    useBorseRequestUpdateMutation(closeModal);

  const { mutateAsync: asyncCreateRequest, isError: isCreateError } =
    useBorseRequestCreateMutation(closeModal);

  const deleteObject = {
    deleteRequest: async (currentRequest) => {
      await asyncDeleteRequest({ campaignId: campaign?.id, request: currentRequest });
    },
    isError: isError,
    reset: reset,
  };

  const updateObject = {
    updateRequest: async (currentRequest, formData, formWatch, lastCompletedStep) => {
      await asyncUpdateRequest({
        survey,
        campaignId: campaign?.id,
        request: currentRequest,
        formData,
        values: formWatch,
        email: formWatch[survey?.definition?.sections[0].questions[6].id],
        phone: formWatch[survey?.definition?.sections[0].questions[4].id],
        isRequestForMe:
          Number(formWatch[survey?.definition?.sections[0].questions[3].id]) ===
          Number(survey?.definition?.sections[0].questions[3].answers[0].id),
        studentFirstName: formWatch[survey?.definition?.sections[1].questions[0].id],
        studentLastName: formWatch[survey?.definition?.sections[1].questions[1].id],
        school: survey?.definition?.sections[1].questions[5]?.answers?.find(
          (ans) => ans.id === Number(formWatch[survey?.definition?.sections[1].questions[5].id])
        )?.label,
        refundAmount: formWatch[survey?.definition?.sections[11].questions[2].id],
        lastCompletedStep,
      });
    },
    isError: isUpdateError,
  };

  const createObject = {
    createRequest: async (formData, formWatch, lastCompletedStep) => {
      await asyncCreateRequest({
        survey,
        campaignId: campaign?.id,
        formData,
        values: formWatch,
        email: formWatch[survey?.definition?.sections[0].questions[6].id],
        phone: formWatch[survey?.definition?.sections[0].questions[4].id],
        isRequestForMe:
          Number(formWatch[survey?.definition?.sections[0].questions[3].id]) ===
          Number(survey?.definition?.sections[0].questions[3].answers[0].id),
        lastCompletedStep,
      });
    },
    isError: isCreateError,
  };

  return (
    <DiscardRequestModal
      show={!!discardModal}
      closeModal={closeModal}
      formWatch={formWatch}
      lastCompletedStep={lastCompletedStep}
      labels={labels}
      survey={survey}
      currentRequest={currentRequest}
      formData={formData}
      skipUpdate={skipUpdate}
      setCurrentRequest={setCurrentRequest}
      setCurrentSectionIndex={setCurrentSectionIndex}
      deleteObject={deleteObject}
      updateObject={updateObject}
      createObject={createObject}
    />
  );
};

export default BorseDiscardRequestModal;
